import React from 'react';

// This is optional but highly recommended to prevent memory leak.
// const cache = createIntlCache();

// const intl = createIntl(
//   {
//     locale: 'en',
//     messages: enUS,
//   },
//   cache,
// );

// export default intl;

let intl = null;
export function setIntl(value) {
  intl = value;
}

const boldText = (chunks) => <b>{chunks}</b>;
const underlineText = (chunks) => <u>{chunks}</u>;
const linkText = (chunks, _href) => <a href={_href}>{chunks}</a>;
const paragraph = (chunks) => <p>{chunks}</p>;
const lineBreak = () => <br />;
const strikeTrough = (chunks) => <s>{chunks}</s>;
const italicText = (chunks) => <i>{chunks}</i>;
const quoteText = (chunks) => <q>{chunks}</q>;
const header1Text = (chunks) => <h1>{chunks}</h1>;

/**
 *
 * @param {object} value if using <a/> need to pass _href
 * @returns
 */
export const solvedHtmlMessage = ({...value}) => ({
  a: (...chunks) => linkText(chunks, value._href),
  u: underlineText,
  b: boldText,
  p: paragraph,
  br: lineBreak,
  s: strikeTrough,
  i: italicText,
  q: quoteText,
  h1: header1Text,
  ...value,
});

// For middleware usage.
/**
 * Formats an HTML message using the provided message descriptor, values, and options. This function is an expansion of the 'formatMessage' function provided by react-intl, specifically designed for handling HTML messages.
 * @param {object} desc - The message descriptor object containing the properties 'id', 'description', and 'defaultMessage' as required by react-intl.
 * @param {object} [value=null] - An optional object containing values to be formatted into the message. Each key in this object corresponds to a placeholder in the message.
 * @param {object} [opt=null] - An optional object containing additional formatting options. This object can include any options supported by react-intl's 'formatMessage' function.
 * @returns {string} The formatted HTML message.
 * @see {@link https://formatjs.io/docs/getting-started/installation} for more information on react-intl and its formatMessage function.
 * @example
 * // Simple usage:
 * const messageDescriptor = {
 *   id: 'app.greeting',
 *   description: 'Greeting message',
 *   defaultMessage: 'Hello, {name}!'
 * };
 * const formattedMessage = formatHTMLMessage(messageDescriptor, { name: 'World' });
 * // Result: 'Hello, World!'
 *
 * // With additional options:
 * const opt = { localeMatcher: 'best fit' };
 * const formattedMessage = formatHTMLMessage(messageDescriptor, { name: 'World' }, opt);
 * // Result: 'Hello, World!' (formatted according to the localeMatcher option)
 *
 * // using tag html a (<a/>): please add _href in the parameter value
 * const opt = { localeMatcher: 'best fit' };
 * const formattedMessage = formatHTMLMessage(messageDescriptor, { name: 'World', _href: 'link' });
 * // Result: '<a href={"link"}>Hello, World!</a>'
 */
export const formatMessage = (desc = {}, value = {}, opts = null) => {
  const {formatMessage: formatMsg} = intl;
  return Object.keys(value).length === 0
    ? formatMsg(desc, value, opts)
    : replaceValueMessage(formatMsg(desc, value, opts), value);
};

/**
 * Formats an HTML message using the provided message descriptor, values, and options. This function is an expansion of the 'formatMessage' function provided by react-intl, specifically designed for handling HTML messages.
 * @param {object} messageDescriptor - The message descriptor object containing the properties 'id', 'description', and 'defaultMessage' as required by react-intl.
 * @param {object} [value=null] - An optional object containing values to be formatted into the message. Each key in this object corresponds to a placeholder in the message.
 * @param {object} [opt=null] - An optional object containing additional formatting options. This object can include any options supported by react-intl's 'formatMessage' function.
 * @returns {string} The formatted HTML message.
 * @see {@link https://formatjs.io/docs/getting-started/installation} for more information on react-intl and its formatMessage function.
 * @example
 * // Simple usage:
 * const messageDescriptor = {
 *   id: 'app.greeting',
 *   description: 'Greeting message',
 *   defaultMessage: 'Hello, {name}!'
 * };
 * const formattedMessage = formatHTMLMessage(messageDescriptor, { name: 'World' });
 * // Result: 'Hello, World!'
 *
 * // With additional options:
 * const opt = { localeMatcher: 'best fit' };
 * const formattedMessage = formatHTMLMessage(messageDescriptor, { name: 'World' }, opt);
 * // Result: 'Hello, World!' (formatted according to the localeMatcher option)
 *
 * // using tag html a (<a/>): please add _href in the parameter value
 * const opt = { localeMatcher: 'best fit' };
 * const formattedMessage = formatHTMLMessage(messageDescriptor, { name: 'World', _href: 'link' });
 * // Result: '<a href={"link"}>Hello, World!</a>'
 */
export const formatHtmlMessage = ({id, description, defaultMessage}, value = {}, opt = null) => {
  const {formatMessage: formatMsg} = intl;
  const messageDescriptor = {};
  if (id) messageDescriptor.id = id;
  if (description) messageDescriptor.description = description;
  if (defaultMessage) messageDescriptor.defaultMessage = defaultMessage;

  return formatMsg(
    messageDescriptor,
    {
      ...solvedHtmlMessage({...value}),
    },
    opt,
  );
};

const replaceValueMessage = (message, value) => {
  if (typeof message !== 'string') {
    return message;
  }

  const replacements = replaceKeysWithBraces(value);
  const pattern = new RegExp(Object.keys(replacements).join('|'), 'g');

  return message.replace(pattern, (matched) => replacements[matched]);
};

const replaceKeysWithBraces = (jsonObj) =>
  Object.keys(jsonObj).reduce((result, key) => {
    result[`{${key}}`] = jsonObj[key];
    return result;
  }, {});
